export default __webpack_public_path__ + "45d8da869d66d19bfb12c713639c9385.gif";